import { render } from "./ProjectExplorer.vue?vue&type=template&id=538c295e"
import script from "./ProjectExplorer.vue?vue&type=script&lang=ts"
export * from "./ProjectExplorer.vue?vue&type=script&lang=ts"

import "./ProjectExplorer.vue?vue&type=style&index=0&id=538c295e&lang=scss"
script.render = render

export default script